import React from "react";

import imageOne from "../../resource/meditate/external-retreat/rules and regulations/1.png";
import imageThree from "../../resource/meditate/external-retreat/rules and regulations/2.png";

const OrganizerInstructions = () => {
  return (
    <div className="externalRules-page inside-pages dark-gold">
      <div className="right-box">
        <img
          src={imageOne}
          alt="Right Top Image"
          className="right-image"
          width={300}
        />
      </div>

      <h1 className="mt-4 dark-gold font-main p-4">Organizer Instructions</h1>
      <h1 className="mt-4 dark-gold font-second p-4">Guest Speaker Retreats</h1>
      <div className="p-4 mt-5">
        <p className="h4 mt-6">
          The Bhaddeka Vihari Monastery and Meditation Centre is pleased to
          offer its premises for retreats conducted by external teachers,
          providing an opportunity for the community to invite esteemed teachers
          from the Theravada Buddhist Tradition, whether Sangha members or
          laypersons.
        </p>

        <h1 className="mt-4 dark-gold font-second">
          Facilities Available for Retreats:
        </h1>

        <p className="h4 mt-5 ">&#x2022; Main Dhamma Hall</p>
        <p className="h4 mt-5 ">&#x2022; Dana Hall</p>
        <p className="h4 mt-5 ">&#x2022; 26 Single Kutis with full amenities</p>
        <p className="h4 mt-5 ">&#x2022; Walking meditation paths</p>
        <p className="h4 mt-5 ">&#x2022; Spacious open areas</p>
        <p className="h4 mt-5 ">&#x2022; Various sanitary facilities</p>

        <p className="h4 mt-5">
          Cushions and chairs are available in the Dhamma Hall, if needed.
        </p>
        <h1 className="mt-6 dark-gold font-second">
          Retreat Organization Process:
        </h1>
        <p className="h4 mt-5">
          To organize a retreat with a guest teacher, the following process must
          be adhered to:
        </p>

        <p className="h4 mt-5 ">
          1.<span className="dark-gold text-bold"> Communication</span> All
          communication regarding the proposed retreat with the external teacher
          must be directed to the Bhaddeka Vihari Meditation Centre.
        </p>
        <p className="h4 mt-5 ">
          2.<span className="dark-gold text-bold"> Application</span> An online
          application must be submitted by the external retreat organizer at
          least three weeks prior to the proposed retreat to allow sufficient
          time for review.
        </p>
        <p className="h4 mt-5 ">
          3.{" "}
          <span className="dark-gold text-bold"> Preliminary Discussion</span>A
          discussion with the Retreat Centre is required to provide information
          about the guest teacher, the retreat’s length and dates, and other
          relevant details.
        </p>
        <p className="h4 mt-5 ">
          4.<span className="dark-gold text-bold"> Evaluation</span> The Retreat
          Centre will evaluate the retreat's suitability, the guest teacher, and
          the availability of space through its standard internal review
          process.
        </p>
        <p className="h4 mt-5 ">
          5.<span className="dark-gold text-bold"> Assessment</span> Further
          discussions will determine the number of rooms and cottages required
          and address any needs regarding existing equipment.
        </p>
        <p className="h4 mt-5 ">
          6.<span className="dark-gold text-bold"> Requirements</span> Any
          specific requirements related to accommodation, buildings, or
          equipment must be discussed and agreed upon.
        </p>
        <p className="h4 mt-5 ">
          7.<span className="dark-gold text-bold"> Final Decision</span> After
          considering all factors, the Retreat Centre will make a final decision
          regarding the proposed retreat.
        </p>
        <p className="h4 mt-5 ">
          8.<span className="dark-gold text-bold"> Written Confirmation</span>{" "}
          The Retreat Centre will send the final decision in writing to the
          organizer. The organizer should wait for this confirmation before
          proceeding with further arrangements.
        </p>

        <h1 className="mt-6 dark-gold font-second">
          Responsibilities of the Retreat Centre:
        </h1>
        <p className="h4 mt-5 ">
          &#x2022;<span className="dark-gold text-bold"> Premises</span>{" "}
          The Retreat Centre provides only the premises for the retreat.
        </p>
        <p className="h4 mt-5 ">
          &#x2022;<span className="dark-gold text-bold"> Teacher Accommodation</span>{" "}
          Accommodation for the teacher will be provided at the Teachers' Cottage.
        </p><p className="h4 mt-5 ">
          &#x2022;<span className="dark-gold text-bold"> Retreatant Accommdation</span>{" "}
          The Retreat Centre is responsible for providing agreed accommodation facilities to retreatants.
        </p><p className="h4 mt-5 ">
          &#x2022;<span className="dark-gold text-bold"> Maintenance</span>{" "}
          The Retreat Centre is responsible for maintaining the agreed accommodation facilities and attached equipment.
        </p><p className="h4 mt-5 ">
          &#x2022;<span className="dark-gold text-bold"> Publicity</span>{" "}
          The Retreat Centre is not responsible for publicizing the retreat.
        </p><p className="h4 mt-5 ">
          &#x2022;<span className="dark-gold text-bold"> Schedule</span>{" "}
          The Retreat Centre is not involved in designing the retreat schedule but advises that the usual breakfast (6:30 am) and lunch (11:00 am) times should not be changed.
        </p><p className="h4 mt-5 ">
          &#x2022;<span className="dark-gold text-bold"> Trasport</span>{" "}
          The Retreat Centre is not responsible for transport arrangements for the teacher or retreatants.
        </p><p className="h4 mt-5 ">
          &#x2022;<span className="dark-gold text-bold"> Retreatants</span>{" "}
          The Retreat Centre is not responsible for retreatants' matters such as accommodation plans, food, beverages, well-being, sanitary needs, medical requirements, or safety.
        </p><p className="h4 mt-5 ">
          &#x2022;<span className="dark-gold text-bold"> Teacher</span>{" "}
          The Retreat Centre is not responsible for the guest teacher’s guidance, teachings, or recommendations.
        </p><p className="h4 mt-5 ">
          &#x2022;<span className="dark-gold text-bold"> Visa</span>{" "}
          The Retreat Centre has no involvement in obtaining visas for overseas guest teachers or retreatants.
        </p>


        <h1 className="mt-6 dark-gold font-second">
        Responsibilities of the Organizer:
        </h1>
        <p className="h4 mt-5 ">
          &#x2022;<span className="dark-gold text-bold"> Atmosphere</span>{" "}
          Maintain a peaceful and calm atmosphere at all times.
        </p>

        <p className="h4 mt-5 ">
          &#x2022;<span className="dark-gold text-bold"> Prohibitions</span>{" "}
          Ensure no drugs, alcohol, recreational drugs, or smoking on the premises.
        </p>

        <p className="h4 mt-5 ">
          &#x2022;<span className="dark-gold text-bold"> Dress Code</span>{" "}
          Ensure that retreatants dress modestly, avoiding short trousers, singlets, and revealing clothing. Retreatants must wear white clothing.
        </p>

        <p className="h4 mt-5 ">
          &#x2022;<span className="dark-gold text-bold"> Dana Times</span>{" "}
          Adhere to the usual breakfast (6:30 am) and lunch (11:00 am) times.
        </p>

        <p className="h4 mt-5 ">
          &#x2022;<span className="dark-gold text-bold"> Room Lockup</span>{" "}
          Please ensure that retreatants are reminded to securely lock their rooms at all times when they are not present.
        </p>

        <p className="h4 mt-5 ">
          &#x2022;<span className="dark-gold text-bold"> Key Collection</span>{" "}
          Agree on a date and time to collect the keys for the rooms and cottages close to the retreat date.
        </p>


        <h1 className="mt-6 dark-gold font-second">
        End of Retreat Responsibilities:
        </h1>
        <p className="h4 mt-5 ">
          &#x2022;<span className="dark-gold text-bold"> Personal Items</span>{" "}
          Ensure that no personal items are left behind.
        </p>

        <p className="h4 mt-5 ">
          &#x2022;<span className="dark-gold text-bold"> Dhamma Hall</span>{" "}
          Clean the Dhamma Hall, including floors and carpets. Cleaning equipment is available in the storeroom.
        </p>

        <p className="h4 mt-5 ">
          &#x2022;<span className="dark-gold text-bold"> Dana Hall</span>{" "}
          Clean and properly store all items in the Dana Hall, and mop any wet areas.
        </p>

        <p className="h4 mt-5 ">
          &#x2022;<span className="dark-gold text-bold"> Sanitary Facilities</span>{" "}
          Clean all common toilets, bathrooms, and kitchenettes.
        </p>

        <p className="h4 mt-5 ">
          &#x2022;<span className="dark-gold text-bold"> Paths and Corridors</span>{" "}
          Ensure these areas are cleaned.
        </p>

        <p className="h4 mt-5 ">
          &#x2022;<span className="dark-gold text-bold"> Rooms and Cottages</span>{" "}
          Clean and vacuum all rooms and cottages, including wet areas.
        </p>

        <p className="h4 mt-5 ">
          &#x2022;<span className="dark-gold text-bold"> Utilities</span>{" "}
          Switch off all used lights and air conditioning equipment.
        </p>

        <p className="h4 mt-5 ">
          &#x2022;<span className="dark-gold text-bold"> Damage Report</span>{" "}
          Inform the Retreat Centre of any damage or worn-out items.
        </p>

        <p className="h4 mt-5 ">
          &#x2022;<span className="dark-gold text-bold"> Key Return</span>{" "}
          Hand over all room and cottage keys to the Retreat Centre office after the retreat.
        </p>

       

        <h1 className="mt-6 dark-gold font-second">
        Special Circumstances:
        </h1>
        <p className="h4 mt-5 ">
        The Monastery and Meditation Centre maintain a Dana roster for breakfast and lunch throughout the year. Generous donors often provide meals for guest speaker retreatants. The Retreat Centre can notify organizers of dates when Dana meals for retreatants will be available. The organizer should discuss these arrangements with the Retreat Centre, and any remaining meal gaps must be filled by the organizer. 
        </p>

        <p className="h4 mt-5 ">No dinner will be provided during the retreat period. Retreatants who require dinner for medical reasons are kindly requested to make private arrangements for their meals through the retreat organizer. These privately arranged meals should be consumed in a manner that does not disturb or interfere with other retreatants.</p>
        <p className="h4 mt-5 ">Due to the high cost of maintaining the Retreat Centre, there is a charge for guest speaker retreats.</p>
        <p className="h4 mt-5 ">For further inquiries or to discuss potential retreats, please contact the Bhaddeka Vihari Meditation Centre directly.</p>


        <h1 className="mt-6 dark-gold font-second">
        Required Items for Retreatants
      </h1>
      <p className="h4 mt-5 ">A bed, mattress, and pillow are provided. However, please bring the following items:</p>
    <p className="h4 mt-5"><span className="text-bold">&#x2022; Bedding:</span> Bed linen, pillowcase, and a blanket or quilt (or any other bedding items you may need).</p>
<p className="h4 mt-4">Note: If you are from Victoria, please bring these items. For interstate or overseas visitors, bed linen will be provided.</p>
<p className="h4 mt-5"><span className="text-bold">&#x2022; Warm Clothing:</span> As the region is usually cool, it is advisable to bring jackets, socks, beanies, etc.
</p>
<p className="h4 mt-5"><span className="text-bold">&#x2022; Personal Items:</span> Towel, toiletries, personal hygiene items, and any necessary medications.
</p>
<p className="h4 mt-5"><span className="text-bold">&#x2022; Clothing for the Retreat:</span> Please bring enough clothing for the entire retreat period. White or light-colored clothing is recommended. Due to limited washing facilities, it is important to have enough clothing for the duration of the retreat.</p>
       
       
        <h1 className="mt-6 dark-gold font-second">
      Optional Items to Consider Bringing:
      </h1>
      <p className="h4 mt-5 ">
        &#x2022; Raincoat / Umbrella
      </p>

      <p className="h4 mt-5 ">
        &#x2022; Hot water bottle (for warmth in bed)
      </p>

      <p className="h4 mt-5 ">
        &#x2022; Slippers and warm shoes
      </p>

      <p className="h4 mt-5 ">
        &#x2022; Small blanket or wrap for use in the hall
      </p>

      <p className="h4 mt-5 ">
        &#x2022; Drinking water bottle or vacuum flask
      </p>

      <p className="h4 mt-5 ">
        &#x2022; Torch and alarm clock
      </p>

      <p className="h4 mt-5 ">
        &#x2022; Personal medication
      </p>


      <p className="h4 mt-6"><span className="text-bold">&#x2022; Meditation Cushions:</span> Cushions are available in the meditation hall, but you are welcome to bring your own if preferred. For those who find sitting on cushions difficult, chairs are also available.
      </p>
      </div>

      

      <div className="bottom-box mt-6">
        <img src={imageThree} alt="bottom-image" width={400} />
      </div>
    </div>
  );
};

export default OrganizerInstructions;
